import {
  getSalaryConfigurations as getSalaryConfigurationsService,
  createSalaryConfiguration as createSalaryConfigurationService,
  updateSalaryConfiguration as updateSalaryConfigurationService,
  approveSalaryConfiguration as approveSalaryConfigurationService,
  deleteSalaryConfiguration as deleteSalaryConfigurationService,
} from "services/company/payrollManagement/salaryConfiguration/salaryConfigurationService";
import {
  getSalaryConfigurationsStart,
  getSalaryConfigurationsSuccess,
  getSalaryConfigurationsFailure,
  createSalaryConfigurationStart,
  createSalaryConfigurationSuccess,
  createSalaryConfigurationFailure,
  updateSalaryConfigurationStart,
  updateSalaryConfigurationSuccess,
  updateSalaryConfigurationFailure,
  approveSalaryConfigurationStart,
  approveSalaryConfigurationSuccess,
  approveSalaryConfigurationFailure,
  deleteSalaryConfigurationStart,
  deleteSalaryConfigurationSuccess,
  deleteSalaryConfigurationFailure,
} from "./salaryConfigurationSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all salary configurations
export const fetchSalaryConfigurations =
  (queryParams = {}) =>
  async (dispatch) => {
    try {
      dispatch(getSalaryConfigurationsStart());
      const response = await getSalaryConfigurationsService(queryParams);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(getSalaryConfigurationsSuccess(response.data));
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to fetch salary configurations";
        dispatch(getSalaryConfigurationsFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Fetch salary configurations error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to fetch salary configurations";
      dispatch(getSalaryConfigurationsFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Create a new salary configuration
export const createNewSalaryConfiguration =
  (configData) => async (dispatch) => {
    try {
      dispatch(createSalaryConfigurationStart());
      const response = await createSalaryConfigurationService(configData);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(createSalaryConfigurationSuccess(response.data));
        showSuccessToast(
          response?.meta?.message ||
            "Salary configuration created successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to create salary configuration";
        dispatch(createSalaryConfigurationFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Create salary configuration error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to create salary configuration";
      dispatch(createSalaryConfigurationFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Update a salary configuration
export const updateExistingSalaryConfiguration =
  (configId, configData) => async (dispatch) => {
    try {
      dispatch(updateSalaryConfigurationStart());
      const response = await updateSalaryConfigurationService(
        configId,
        configData,
      );

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(updateSalaryConfigurationSuccess(response.data));
        showSuccessToast(
          response?.meta?.message ||
            "Salary configuration updated successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to update salary configuration";
        dispatch(updateSalaryConfigurationFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update salary configuration error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update salary configuration";
      dispatch(updateSalaryConfigurationFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Approve a salary configuration
export const approveExistingSalaryConfiguration =
  (configId) => async (dispatch) => {
    try {
      dispatch(approveSalaryConfigurationStart());
      const response = await approveSalaryConfigurationService(configId);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(approveSalaryConfigurationSuccess(configId));
        showSuccessToast(
          response?.meta?.message ||
            "Salary configuration approved successfully!",
        );
        return { success: true };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to approve salary configuration";
        dispatch(approveSalaryConfigurationFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Approve salary configuration error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to approve salary configuration";
      dispatch(approveSalaryConfigurationFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Delete a salary configuration
export const deleteExistingSalaryConfiguration =
  (configId) => async (dispatch) => {
    try {
      dispatch(deleteSalaryConfigurationStart());
      const response = await deleteSalaryConfigurationService(configId);

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(deleteSalaryConfigurationSuccess(configId));
        showSuccessToast(
          response?.meta?.message ||
            "Salary configuration inactivated successfully!",
        );
        return { success: true };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to delete salary configuration";
        dispatch(deleteSalaryConfigurationFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Delete salary configuration error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to delete salary configuration";
      dispatch(deleteSalaryConfigurationFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };
